import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Intercepta cualquier formulario/botón que haga update mientras hay zoom
  // y lo difiere hasta que se cierre el zoom
  
  submit(event) {
    const zoomedCard = document.querySelector('.zoomed')
    if (!zoomedCard) {
      // Sin zoom, dejar que se envíe normalmente
      return
    }

    // Hay zoom: prevenir envío y diferir
    event.preventDefault()
    this.deferSubmitUntilZoomClose(event.target.form || event.target, zoomedCard)
  }

  deferSubmitUntilZoomClose(form, zoomedCard) {
    let observer = null
    observer = new MutationObserver(() => {
      if (!zoomedCard.classList.contains('zoomed')) {
        observer.disconnect()
        // Ahora que se cerró el zoom, enviar el formulario
        form.requestSubmit()
      }
    })
    observer.observe(zoomedCard, { attributes: true, attributeFilter: ['class'] })
  }
}
